export const MEDIA_QUERIES = {
  mobile: "(max-width: 767px)",
  tablet: "(min-width: 768px) and (max-width: 1199px)",
  desktop: "(min-width: 1200px)",
  mobileAndTablet: "(max-width: 1199px)",
  tabletAndDesktop: "(min-width: 768px)",
}
